export default __webpack_public_path__ + "static/media/front-img.0d839a5a.jpg";